<template>
  <div
    class="relative pb-6 bg-white dark:bg-neutral-900 overflow-y-auto overflow-x-hidden"
  >
    <div
      class="sticky bg-inherit z-10 top-0 w-full px-2 h-16 gap-2 grid grid-cols-[1fr_auto_1fr] items-center"
    >
      <div>
        <NamiButton
          class="ml-auto"
          @buttonClick="emit('close')"
          :icon="IconX"
          buttonType="secondary"
          text
          pill
        />
      </div>
      <h2 class="font-medium text-xl text-center truncate">Comments</h2>
    </div>
    <FeedCommentsSimple
      v-if="feedId && !feedIdChanged"
      class="px-4 min-w-0"
      feedType="chapter"
      :feedId="feedId"
    />
  </div>
</template>

<script setup lang="ts">
import { IconX } from "@tabler/icons-vue";
import type { UnwrapNestedRefs } from "vue";
import { ReaderManager } from "~/src/reader/managers/reader";

interface Props {
  readerManager: UnwrapNestedRefs<ReaderManager>;
  commentsOpen?: boolean;
}

interface Emits {
  (e: "close"): void;
}

const { readerManager, commentsOpen } = defineProps<Props>();
const emit = defineEmits<Emits>();

const feedIdChanged = ref(false);
const feedId = computed(() => readerManager.getCurrChapterId());

watch(feedId, (v, oldValue) => {
  if (v !== oldValue) {
    feedIdChanged.value = true;
    if (commentsOpen) nextTick().then(() => (feedIdChanged.value = false));
  }
});

watch(
  () => commentsOpen,
  () => {
    feedIdChanged.value = false;
  },
);
</script>
